// extracted by mini-css-extract-plugin
export default {"menu":"MainPageFrame_menu__A5GIo","nav":"MainPageFrame_nav__MLULG"};